import { Text } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { createSearchUrl } from '../url/createSearchUrl';

export const useSearchFeedback = (): VoidFunction => {
  const dispatch = useAppDispatch();
  const { params } = useAppSelector((state) => state.search);

  const trigger = useCallback(() => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:feedbackForm',
          arg: {
            title: 'Search Feedback',
            team: 'insights',
            placeholder:
              "How would you describe the search results you're seeing?",
            customMessage: (
              <Text.Paragraph variant="4" subdued>
                Note: some extra information will be included, including your
                search keywords, filters and other settings, to better help us
                understand your feedback and troubleshoot any issues.
              </Text.Paragraph>
            ),
            extra: {
              q: params.query,
              strict: params.isStrict,
              // The ~ character we use to separate keys and values in the URL ends up parsed as
              // markdown when the feedback conversation is viewed, so we encode it manually to
              // ensure the string isn't formatted as markdown.
              url: createSearchUrl(params).replaceAll('~', '%7e'),
            },
          },
        },
      }),
    );
  }, [dispatch, params]);

  return trigger;
};
